import { inject } from 'vue';
import { externalEventKey } from '../keys';

export function useExternalEventInjection() {
    const externalEventInjection = inject(externalEventKey);
    if (!externalEventInjection) {
        throw new Error('External event not properly injected');
    }
    return externalEventInjection;
}
